var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.user_clients.length > 1
        ? _c(
            "q-btn-dropdown",
            {
              staticClass: "q-mr-sm",
              attrs: {
                label: _vm.getClientLabel,
                icon: "far fa-building",
                flat: ""
              },
              model: {
                value: _vm.show_clients,
                callback: function($$v) {
                  _vm.show_clients = $$v
                },
                expression: "show_clients"
              }
            },
            [
              _c(
                "q-list",
                { attrs: { link: "" } },
                _vm._l(_vm.user_clients, function(item, index) {
                  return _vm.id_user_client_selected != item.id
                    ? _c(
                        "q-item",
                        {
                          key: index,
                          nativeOn: {
                            click: function($event) {
                              return _vm.changeClient(item)
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-main",
                            [
                              _c("q-item-tile", { attrs: { label: "" } }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(item.name) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }